import HoldBlackIcon from 'components/icons/DriveTableIcon/HoldBlack'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import RescheduleIcon from 'components/icons/DriveTableIcon/Reschedule'
import ShortlistIcon from 'components/icons/DriveTableIcon/Shortlist'
import ToBeScheduledIcon from 'components/icons/DriveTableIcon/ToBeScheduled.js'
import React from 'react'
import styled from 'styled-components'
import IntenToOfferIcon from '../../../../components/icons/DriveTableIcon/IntentToOffer'
import OfferAcceptedIcon from '../../../../components/icons/DriveTableIcon/OfferAccepted'
import OfferIssuedIcon from '../../../../components/icons/DriveTableIcon/OfferIssued'

const DriveStatus = ({ status, offerStatus }) => {
  const StyledContainar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `
  const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `
  let colorType
  let tagMessage
  let icon
  if (
    status == 'SCHEDULED' ||
    status == 'HELD_TO_COMPARE' ||
    status == 'STATUS_CONFLICT' ||
    status == 'MOVE_TO_NEXT_ROUND' ||
    status == 'TO_BE_UPDATED' ||
    status == 'REJECT' ||
    status == 'HOLD_TO_COMPARE'
  ) {
    colorType = 'black'
    tagMessage = 'Scheduled'
  } else if (status == 'TO_BE_SCHEDULED') {
    colorType = 'black'
    tagMessage = 'To be scheduled'
    icon = <ToBeScheduledIcon />
  } else if (status == 'INVITED') {
    colorType = 'grey'
    tagMessage = 'Invited'
  } else if (status == 'SHORTLISTED') {
    colorType = 'black'
    tagMessage = 'Shortlisted'
    icon = <ShortlistIcon />
  } else if (status == 'COMPLETED') {
    colorType = 'green'
    tagMessage = 'Completed'
  } else if (status == 'QUALIFIED') {
    colorType = 'green'
    tagMessage = 'Qualified'
  } else if (status == 'REJECTED') {
    colorType = 'black'
    tagMessage = 'Rejected'
    icon = <RejectIcon />
  } else if (status == 'ABSENT') {
    colorType = 'black'
    tagMessage = 'Absent'
    icon = <HoldBlackIcon />
  } else if (status == 'RESCHEDULE_REQUESTED') {
    colorType = '#F3A66E'
    tagMessage = 'Req.Reschedule'
  } else if (status == 'RESCHEDULED') {
    colorType = 'black'
    tagMessage = 'Rescheduled'
    icon = <RescheduleIcon />
  } else if (status == 'RESCHEDULE') {
    colorType = 'black'
    tagMessage = 'Reschedule'
  } else if (status == 'SELECTED') {
    if (offerStatus == 'RELEASED') {
      tagMessage = 'Offer Issued'
      icon = <IntenToOfferIcon />
      colorType = 'black'
    } else if (offerStatus == 'ACCEPTED') {
      tagMessage = 'Offer Accepted'
      icon = <OfferAcceptedIcon />
      colorType = 'black'
    } else if (offerStatus == 'REJECTED') {
      tagMessage = 'Offer Declined'
      icon = <OfferIssuedIcon />
      colorType = 'black'
    } else if (offerStatus == 'JOINED') {
      tagMessage = 'Joined'
      icon = <OfferAcceptedIcon title="Joined" />
      colorType = 'black'
    } else if (offerStatus == 'LEFTED') {
      tagMessage = 'Left'
      icon = <RejectIcon title="Left" />
      colorType = 'black'
    } else if (offerStatus == 'NOT_RELEASED') {
      tagMessage = 'Intent to Offer'
      icon = <ShortlistIcon title="Intent to Offer" />
      colorType = 'black'
    } else {
      tagMessage = 'Update status'
      colorType = '#808697'
    }
  } else if (status == 'RELEASED') {
    colorType = 'green'
    tagMessage = 'Offer letter released'
    icon = <ShortlistIcon />
  } else if (status == 'ACTIVE') {
    colorType = '#808697'
    tagMessage = 'Update status'
  } else if (status == 'OFFER_RECEIVED') {
    colorType = 'black'
    tagMessage = 'Offer received'
  } 
  else if (status == 'SKIPPED') {
    colorType = 'black'
    tagMessage = 'Skipped'
    // icon = <ShortlistIcon />
  }
  else {
    tagMessage = 'Yet to Update'
  }
  return (
    <StyledContainar
      style={{
        color: colorType,
        display: 'flex',
      }}
    >
      {icon && <StyledIcon>{icon}</StyledIcon>}
      <div style={{ fontSize: 'smaller', fontWeight: '500' }}>{tagMessage}</div>
    </StyledContainar>
  )
}

export default DriveStatus
